/**
 * 消息推送
 */
import React from 'react';
import UserList from "../userManage/UserList";
import $ from "jquery";
import {Button, Modal} from "antd";
import {formatDate} from "../../../utils";
import {message} from "../../../view/sysManagement/utils/sysManagementUtils";
import MessagePushAdd from "./MessagePushAdd";

export default class MessagePushList extends UserList {

    getListData() {
        let params = {
            start: this.state.offsite,
            size: this.state.count,
            ...this.state.screenObj
        }
        this.request({
            url: "/cm-sites-mmp/notice/list",
            method: "get",
            body: params,
            callBack: (res) => {
                let listData = [];
                let hideOnSinglePage = true;
                let total = 0;
                if (res && res.data && res.data.length) {
                    listData = res.data;
                    total = res.count;
                    hideOnSinglePage = false;
                }
                this.setState({
                    listData,
                    total,
                    hideOnSinglePage
                }, () => {
                    $('.ant-pagination-options-quick-jumper').find("input").val("");
                })
            }
        });
    }

    getScreenList() {
        return (
            [
                {
                    key: "title",
                    field: "title",
                    placeholder: "请输入消息标题",
                    type: "1",
                }
            ]
        )
    }

    getColumns() {
        return (
            [
                {
                    title: "消息标题",
                    key: 'title',
                    dataIndex: 'title',
                    ellipsis: true,
                },
                {
                    title: "用户类型",
                    key: 'userType',
                    dataIndex: 'userType',
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                height: 30
                            }}>
                                {(() => {
                                    switch (text) {
                                        case 0:
                                            return "全部";
                                        case 1:
                                            return "外部人员";
                                        case 2:
                                            return "内部人员";
                                        case 3:
                                            return "内部管理";
                                        default:
                                            return "-";
                                    }
                                })()}
                            </div>
                        )
                    }
                },
                {
                    title: "所属单位",
                    key: 'deptNameList',
                    dataIndex: 'deptNameList',
                    ellipsis: true,
                    render: (text, record) => {
                        let deptNames = (text && text.length > 0) ? text.join("，") : "-";
                        return (
                            <div style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                                {deptNames}
                            </div>
                        )
                    }
                },
                {
                    title: "发送人",
                    key: 'senderName',
                    dataIndex: 'senderName',
                    ellipsis: true,
                },
                {
                    title: "状态",
                    key: 'status',
                    dataIndex: 'status',
                    ellipsis: true,
                    render: (text, record) => {
                        let status;
                        switch (text) {
                            case 0:
                                status = "已发布";
                                break;
                            case 1:
                                status = "已撤回";
                                break;
                            default:
                                status = "-";
                        }
                        return (
                            <div>{status}</div>
                        )
                    }
                },
                {
                    title: "发送时间",
                    key: 'createTime',
                    dataIndex: 'createTime',
                    ellipsis: true,
                    width: 180,
                    render: (text, record) => {
                        return (
                            <div style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            }}>{text ? formatDate(text) : "-"}</div>
                        )
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 100,
                    render: (text, record) => {
                        return (
                            <div>
                            <span style={{color: "#0050B3", cursor: "pointer", marginRight: 10}}
                                  onClick={() => this.MessagePushAdd.show(record, "onlyView")}>查看</span>
                                {record.status === 1 ?
                                    <span style={{color: "#0050B3", cursor: "pointer"}}
                                          onClick={() => this.delete(record)}>删除</span> :
                                    <span style={{color: "#0050B3", cursor: "pointer"}}
                                          onClick={() => this.withdraw(record)}>撤回</span>}
                            </div>
                        )
                    }
                }
            ]
        )
    }

    delete(record) {
        Modal.confirm({
            title: "确认删除该消息？",
            onOk: () => {
                this.request({
                    url: "/cm-sites-mmp/notice/delete",
                    body: {id: record.id},
                    method: "get",
                    callBack: (res) => {
                        if (res) {
                            message.success("删除成功");
                            if (this.state.listData.length === 1 && this.state.offsite > 1) {
                                this.paginationOnChange(this.state.offsite - 1, this.state.count)
                            } else {
                                this.paginationOnChange(this.state.offsite, this.state.count)
                            }
                        }
                    }
                });
            }
        })
    }

    withdraw(record) {
        Modal.confirm({
            title: "确认撤回该消息？",
            onOk: () => {
                this.request({
                    url: "/cm-sites-mmp/notice/withdraw",
                    body: {id: record.id},
                    method: "get",
                    callBack: (res) => {
                        if (res) {
                            message.success("撤回成功");
                            this.getListData();
                        }
                    }
                });
            }
        })
    }

    renderAddModal() {
        return (
            <MessagePushAdd ref={(MessagePushAdd) => this.MessagePushAdd = MessagePushAdd}
                            refreshList={() => {
                                this.getListData();
                            }}/>
        )
    }

    renderBtn() {
        return (
            <div style={{marginTop: 20}}>
                <Button style={{marginRight: "20px"}} onClick={() => {
                    this.MessagePushAdd.show();
                }} type={"primary"}>
                    新增消息
                </Button>
            </div>
        )
    }
}